var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashCanRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-can-regular"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.75C10.3797 10.75 10.6935 11.0322 10.7432 11.3982L10.75 11.5V17.5C10.75 17.9142 10.4142 18.25 10 18.25C9.6203 18.25 9.30651 17.9678 9.25685 17.6018L9.25 17.5V11.5C9.25 11.0858 9.58579 10.75 10 10.75Z",
    fill: "#660099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7432 11.3982C14.6935 11.0322 14.3797 10.75 14 10.75C13.5858 10.75 13.25 11.0858 13.25 11.5V17.5L13.2568 17.6018C13.3065 17.9678 13.6203 18.25 14 18.25C14.4142 18.25 14.75 17.9142 14.75 17.5V11.5L14.7432 11.3982Z",
    fill: "#660099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7449 4.94696C16.6666 3.72982 15.7019 2.75 14.5 2.75H9.5L9.34463 2.7555C8.16456 2.83929 7.25 3.87063 7.25 5.107V6.75H3L2.89823 6.75685C2.53215 6.80651 2.25 7.1203 2.25 7.5C2.25 7.91421 2.58579 8.25 3 8.25H4.25V19C4.25 20.7952 5.70479 22.25 7.5 22.25H16.5C18.2952 22.25 19.75 20.7952 19.75 19V8.25H21L21.1018 8.24315C21.4678 8.19349 21.75 7.8797 21.75 7.5C21.75 7.08579 21.4142 6.75 21 6.75H16.75V5.107L16.7449 4.94696ZM15.25 6.75H8.75V5.107L8.75605 4.99741C8.80389 4.56789 9.12913 4.25 9.5 4.25H14.5L14.5916 4.2565C14.9533 4.30805 15.25 4.6603 15.25 5.107V6.75ZM5.75 8.25H18.25V19C18.25 19.9668 17.4668 20.75 16.5 20.75H7.5L7.35643 20.7442C6.45685 20.6712 5.75 19.9184 5.75 19V8.25Z",
    fill: "#660099"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanRegular);
export default __webpack_public_path__ + "static/media/trash-can-regular.def39d6af6c0ee8801b1155d413cdb86.svg";
export { ForwardRef as ReactComponent };